<script>
import { saveAs } from 'file-saver/FileSaver'
import { date } from 'quasar'
import { toArrayBuffer, formatDate } from 'src/utils'
import { mapActions, mapMutations, mapState } from "vuex"
export default {
  name: "ReferralReport",
  data() {
    return {
      maximized: false
    };
  },
  computed: {
    ...mapState({
      recruiterReferralModal: s => s.shared.recruiterReferralModal,
      recruiterReferralForm: s => s.reports.recruiterReferralForm
    })
  },
  methods: {
    ...mapMutations(["closeModal"]),
    ...mapMutations("reports", ["changeState"]),
    ...mapActions("reports", [ "generateRecruiterReferral"]),
    toggleMaximized() {
      this.maximized = !this.maximized;
    },
    endDateHandler(val) {
      this.changeState({area:'recruiterReferralForm', field:'END_DATE', val: date.endOfDate(val, 'day')})
    },
    runReport () {
      this.generateRecruiterReferral()
      .then(response => {
        if(response) {
          saveAs(
            new Blob([toArrayBuffer(response.content.data)],
            { type: 'application/octet-stream' }),
            'RecruiterReferral.xlsx'
          )
        }
      })
    }
  }
};
</script>

<template>
  <q-modal class="sl-modal"
  id="recruiterReferralModal"
  :maximized="maximized"
  :value="recruiterReferralModal"
  @hide="closeModal('recruiterReferral')"
  >
  <q-modal-layout>
    <q-toolbar slot="header">
      <q-toolbar-title>
          <q-icon name="fa fa-certificate" /> Recruiter Referral Report
      </q-toolbar-title>
      <!--<q-icon @click.native="toggleMaximized()" size="20px" class="gt-sm" name="filter_none" />-->
      <q-icon @click.native="closeModal('recruiterReferral')" name="clear" />
    </q-toolbar>
    <div style="padding:40px 20px">
      <div class="sl-row">
        <div class="sl-col-12">
            <p style="max-width:350px; margin:0 auto" class="text-center">This report shows all the recruiters and their referrals for a given date range.</p>
        </div>
      </div>
      <div class="sl-row sl-vp">
        <div class="sl-col-6">
          <q-datetime stack-label="Start Date" :value="recruiterReferralForm.START_DATE" @change="val=>changeState({area:'recruiterReferralForm', field:'START_DATE', val: val})"/>
        </div>
        <div class="sl-col-6">
          <q-datetime stack-label="End Date" :value="recruiterReferralForm.END_DATE" @change="endDateHandler"/>
        </div>
      </div>
    </div>
      <q-toolbar slot="footer">
        <q-toolbar-title></q-toolbar-title>
        <q-btn color="green" @click.native="runReport()" icon="fa fa-gear" label="Run" />&nbsp;
        <q-btn outline color="faded" @click.native="closeModal('recruiterReferral')" label="Cancel" />
      </q-toolbar>
    </q-modal-layout>
  </q-modal>
</template>

<style lang="stylus">
</style>